export const replaceFalsyProps = (_: string, value: unknown) => {
  if (value === "" || value === null || value === undefined) {
    return undefined
  }

  return value
}
